export const CREATE_REFERRAL = "CREATE_REFERRAL"
export const GET_DROPDOWN_PROJECT_TYPES = "GET_DROPDOWN_PROJECT_TYPES"
export const APPROVE_REFERRAL="APPROVE_REFERRAL"
export const GET_REFERRAL_DETAILS="GET_REFERRAL_DETAILS"
export const GET_REFERRAL_LIST="GET_REFERRAL_LIST"
export const SITE_CALLING_LIST="SITE_CALLING_LIST"
export const SITE_CALLING_LOG="SITE_CALLING_LOG"
export const SITE_CALLING_FORM="SITE_CALLING_FORM"
export const SITE_CALLING_FILTERS="SITE_CALLING_FILTERS"

